module.exports = __webpack_public_path__ + "static/media/welcome.20479b6c.jpg";